import { Button } from "@/components/ui/button";

/**
 * Right-panel intro content — shared by every diagnostic. Reads
 * `meta` / `title` / `subtitle` / `email_expectation` / `cta_label`
 * off `definition.introCopy` (same shape for every diagnostic's
 * generic engine, §5.1's "tell them up front a free report will be
 * emailed" rule), styled with the site's own palette.
 */
export const IntroPanel = ({ introCopy, onStart, starting }) => (
  <div data-testid="readiness-intro-card">
    <p className="font-body text-xs uppercase tracking-[0.2em] text-terracotta mb-4">{introCopy.meta}</p>
    <h1 className="font-serif text-3xl md:text-4xl text-charcoal mb-4 leading-tight">{introCopy.title}</h1>
    <p className="font-body text-base md:text-lg text-ink-soft leading-relaxed mb-6">{introCopy.subtitle}</p>
    <p
      className="font-body text-sm text-ink leading-relaxed mb-8 rounded-lg px-4 py-3 bg-paper-deep"
      data-testid="readiness-email-expectation"
    >
      {introCopy.email_expectation}
    </p>
    <Button
      data-testid="readiness-start-button"
      onClick={onStart}
      disabled={starting}
      className="px-8 py-6 text-base font-medium rounded-full bg-terracotta text-paper hover:bg-terracotta-dark transition-colors"
    >
      {starting ? "..." : introCopy.cta_label}
    </Button>
  </div>
);

export default IntroPanel;
